export * from './WiredOrdersPage';
export { default } from './WiredOrdersPage';
